<template>
  <div class="panorama">
    <Navigation />
    <div 
        class="content-container mp-container"
    >
        <div
            class="aside-left clickable"
            @click="navTo('rundgang')"
        ><img 
            src="/img/museum-pankow-grundriss_icon.png"
            class="plan-icon"
        ></div>
        <div class="main">
          <div
            class="panorama-container" 
          >
            <iframe 
                :src="panoramaSrc()" 
                width="100%"
                height="600px"
                style="border:none;"
            >
            </iframe>
          </div>
        </div>
        <div
            class="aside-right "
        >
            <DetailList :current="panoramaNumber"/>
        </div>
    </div>
  </div>
</template>

<script>
// @ is an alias to /src
import { mapGetters } from 'vuex'
import DetailList from '@/components/Detail-list'
import Navigation from '@/components/Navigation'

export default {
  name: 'panorama-display',
  components: {
    DetailList,
    Navigation
  },
  data () {
    return {
        panoramaNumber: null,
        panoramas: [
            {
                orderNumber: 1,
                title: 'Berliner Zimmer',
                src: 'https://mp-panoramas.culture-to-go.de/berliner-zimmer/index.html'
            },
            {
                orderNumber: 2,
                title: 'Wohnzimmer',
                src: 'https://mp-panoramas.culture-to-go.de/wohnzimmer/index.html'
            },
            {
                orderNumber: 3,
                title: 'Herrenzimmer',
                src: 'https://mp-panoramas.culture-to-go.de/herrenzimmer/index.html'
            }

        ]
    }
  },
  methods: {
    navTo(target) {
        this.$router.push(`/${target}`)
    },
    panoramaSrc() {
        return this.panoramas.find(p => p.orderNumber.toString() === this.panoramaNumber)
            ? this.panoramas.find(p => p.orderNumber.toString() === this.panoramaNumber).src
            : undefined
    }
  },
  computed: {
    ...mapGetters({
        rooms: 'getRoomsData',  
        player: 'getPlayerStatus',
        pagesData: 'getPagesData',
        modalState: 'getModalState'
    }),
  },
  created () {
    this.panoramaNumber = this.$route.params.id
  }
}
</script>
<style lang="scss" scoped>
@import '@/scss/custom.scss';
.panorama {
    position: relative;
    background-image: url('/img/museum-pankow-back-1400x900.jpg');
    background-repeat: no-repeat;
    background-position: top;
    background-size: cover;
}
.content-container {
    display: grid;
    grid-template-columns: auto 1fr auto;
    padding-top: 6rem;
    align-content: space-between;
}
.main {
    margin: 2rem 6rem 2rem 4rem;
}
.aside-left {
    margin: 2rem 1rem;
    .plan-icon {
        max-width: 8rem;
    }
}
.panorama-container {
   background-color: $grey-light-80;
}
</style>